/**
 * Centralized Error Codes
 * Single source of truth for all error codes across frontend/backend
 */

// Database Error Codes
export enum DatabaseErrorCode {
  RECORD_NOT_FOUND = 'DB_001',
  DUPLICATE_RECORD = 'DB_002',
  FOREIGN_KEY_CONSTRAINT = 'DB_003',
  DATABASE_ERROR = 'DB_004',
  TRANSACTION_FAILED = 'DB_005',
}

// Combined Error Codes type
export type ErrorCode = DatabaseErrorCode
